module.exports = __webpack_public_path__ + "img/status7.07658e10.svg";